import './App.css';

import { Amplify, Auth } from 'aws-amplify';
import { Authenticator } from 'aws-amplify-react';
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AwsProfiles } from './config/aws-profile';
import Layout from './pages/Layout';
import { routerBaseName } from './components/utils';
import ReactGA from 'react-ga';
import { createBrowserHistory } from 'history';
import { ConfigProvider, App as AntApp } from 'antd';
import { antdTheme, colors } from './theme';

const amplifyEnv = process.env.REACT_APP_AMPLIFY_ENVIRONMENT || 'production';

Amplify.configure({
  ...AwsProfiles.get(amplifyEnv),
  graphql_headers: async () => ({
    Authorization: (await Auth.currentSession()).getIdToken().getJwtToken(),
  }),
});

const history = createBrowserHistory();

const googleAnalyticsId = process.env.REACT_APP_GOOGLE_ANALYTICS_ID;
if (googleAnalyticsId) {
  ReactGA.initialize(googleAnalyticsId);
  history.listen(location => {
    ReactGA.set({ page: location.pathname });
    ReactGA.pageview(location.pathname);
  });
}

const myTheme = {
  toast: {
    color: colors.red4,
    width: '300px',
    textAlign: 'center',
    border: '0.75pt solid ' + colors.red4,
    borderRadius: '4px',
    padding: '10pt',
    position: 'absolute',
    backgroundColor: 'white',
    left: '0',
    right: '0',
    margin: '10pt auto 0',
    zIndex: '50',
  },
};

const App: React.FC = () => (
  <Router basename={routerBaseName}>
    <ConfigProvider theme={antdTheme}>
      <AntApp>
        <Authenticator hideDefault={true} theme={myTheme}>
          <Layout />
        </Authenticator>
      </AntApp>
    </ConfigProvider>
  </Router>
);

export default App;
